const initialState = {
	'poses': [],
	'menu': [],
	'products': [],
	'comments': [],
	'paymentTypes': [],
	'externalCouriers': [],
	'externalMenu': [],
	'autoAddRules': [],
	'discounts': { by_pos: {} },
}

const filterData = function (state = initialState, action) {
	switch (action.type) {
		case "SET_DELIVERY_DATA":
			return {
				...state,
				'poses': action.payload.poses ?? state.poses,
				'menu': action.payload.menu ?? state.menu,
				'products': action.payload.products ?? state.products,
				'comments': action.payload.comments ?? state.comments,
				'paymentTypes': action.payload.paymentTypes ?? state.paymentTypes,
				'externalCouriers': action.payload.externalCouriers ?? state.externalCouriers,
				'externalMenu': action.payload.externalMenu ?? state.externalMenu,
				'autoAddRules': action.payload.autoAddRules ?? state.autoAddRules,
				'discounts': action.payload.discounts ?? state.discounts,
			};
		default:
			return state;
	}
};

export default filterData;
